// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".downpDownMobile .dropdown-menu{width:100vw!important;left:-5px!important;padding-top:0!important;border-bottom-left-radius:0;border-bottom-right-radius:0;height:100vh!important}", ""]);
// Exports
module.exports = exports;
